// 中文翻译文件
export default {
  common: {
    welcome: '欢迎',
    submit: '提交',
    cancel: '取消',
    confirm: '确认',
    loading: '加载中...',
    success: '成功',
    error: '错误',
    search: '搜索',
    retry: '重试'
  },
  menu: {
    home: '首页',
    products: '产品中心',
    solutions: '解决方案',
    support: '技术支持',
    about: '关于我们'
  },
  products: {
    intelligentChannel: '智能通道系统',
    middleware: '物联网中间件',
    sensor: '传感器及组件',
    learnMore: '了解详情',
    fetchFailed: '获取产品数据失败',
    allTypes: '所有类型',
    productType: '产品类型',
    noProducts: '暂无产品数据',
    loadFailed: '加载产品失败，请刷新页面重试'
  },
  homepage: {
    learnMore: '了解详情',
    productCenter: '产 品 中 心',
    latestProduct: 'LATEST PRODUCT'
  },
  chatbot: {
    onlineService: '在线客服',
    title: '在线客服',
    welcomeMessage: '您好！我是智能客服，有什么可以帮助您的吗？',
    placeholder: '请输入您的问题...',
    send: '发送',
    sending: '发送中...',
    searching: '正在为您检索...'
  },
  // 添加footer模块
  footer: {
    slogan: '创新让我们与众不同',
    copyright: '2018版权所有 © 法彼特电气(上海)有限公司 沪ICP备11031202号-1',
    security: '沪公网安备 31010402006823号',
    home: '首页',
    products: '产品中心',
    solutions: '解决方案',
    techSupport: '技术支持',
    contact: '关于我们',
    phone: '电话：',
    email: '邮箱：'
  },
  aboutPage: {
    title: '关于我们',
    subtitle: '企业简介',
    learnMore: '了解详情',
    buildingAlt: '公司大楼',
    description: 'description text' // 添加中文静态翻译
  },
  languages: {
    zh: '中文',
    en: '英文'
  },
  productDetail: {
    specifications: '规格说明',
    description: '产品描述',
    applications: '应用场景',
    technicalParams: '技术参数',
    relatedProducts: '相关产品',
    back: '返回上一级',
    dimensionDetails: '尺寸详情',
    dimensionImage: '产品尺寸图',
    noProduct: '未找到该产品信息',
    loadError: '无法加载产品详情',
    noProductId: '产品ID不存在',
    noProductData: '未找到产品数据',
    loadFailed: '加载失败，请稍后重试',
    paramName: '参数名称',
    paramValue: '参数值',
    feature1: '组网灵活',
    feature2: '协议丰富',
    feature3: '工业级设计',
    feature4: '接口丰富'
  },
  techSupport: {
    resourcesDownload: '资源下载',
    manualDownload: '说明书下载',
    softwareDownload: '软件下载',
    download: '下载',
    noSoftware: '暂无软件资源',
    noManual: '暂无说明书资源',
    faq: '常见问题',
    question: 'Q',
    answer: 'A',
    noFaq: '暂无常见问题',
    technicalDocs: '技术文档下载',
    noDocuments: '暂无技术文档',
    downloadFailed: '下载文件失败，请重试'
  },
  solutions: {
    allTypes: '所有类型',
    solutionType: '解决方案类型',
    solution: '解决方案',
    noSolutions: '暂无解决方案数据',
    loadFailed: '加载解决方案失败，请刷新页面重试',
    defaultDescription: '专业的解决方案，为您提供全方位的技术支持和服务保障。',
    professionalCustom: '专业定制',
    efficientReliable: '高效可靠',
    loadingDetail: '正在加载解决方案详情...',
    tableFormatError: '表格数据格式错误',
    imageUrlInvalid: '图片地址无效',
    noDetailContent: '暂无详细内容，请联系管理员添加段落内容',
    noSolutionId: '解决方案ID不存在',
    noSolutionData: '未找到解决方案数据',
    loadDetailFailed: '加载失败，请稍后重试',
    techLeading: '技术领先',
    servicePerfect: '服务完善'
  },
  contact: {
    companyIntro: '公司简介',
    values: '价值观',
    colorMeanings: '色彩寓意',
    companyBuilding: '公司大楼',
    showFormHint: '点击或悬浮显示留言反馈表单',
    contactUs: '联 系 我 们',
    messageFeedback: '留言反馈',
    name: '姓名',
    email: '邮箱',
    phone: '电话',
    message: '留言内容',
    namePlaceholder: '请输入您的姓名',
    emailPlaceholder: '请输入您的邮箱',
    phonePlaceholder: '请输入您的电话',
    messagePlaceholder: '请输入您的留言内容',
    submitting: '提交中...',
    submit: '提交留言',
    submitSuccess: '留言提交成功！',
    submitError: '提交失败，请稍后重试。'
  }
}